<hr class="hr" [style.height]="height" />
